import { api } from './client';
import type { Product } from '../types';

const CATALOG_TTL_MS = 5 * 60 * 1000;

let cachedProducts: Product[] | null = null;
let cachedAt = 0;
let pendingRequest: Promise<Product[]> | null = null;

/**
 * Shared public catalog source. It deduplicates concurrent requests and keeps
 * navigation between product surfaces immediate without making data permanent.
 */
export function getProductCatalog(options?: { refresh?: boolean }): Promise<Product[]> {
  const fresh = cachedProducts && Date.now() - cachedAt < CATALOG_TTL_MS;
  if (!options?.refresh && fresh) return Promise.resolve(cachedProducts as Product[]);
  if (!options?.refresh && pendingRequest) return pendingRequest;

  pendingRequest = api
    .listProducts()
    .then((products) => {
      cachedProducts = products;
      cachedAt = Date.now();
      return products;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
}

export function invalidateProductCatalog() {
  cachedProducts = null;
  cachedAt = 0;
}
